import { render } from "./WCMobileHeader.vue?vue&type=template&id=4e83b177&scoped=true"
import script from "./WCMobileHeader.vue?vue&type=script&lang=js"
export * from "./WCMobileHeader.vue?vue&type=script&lang=js"

import "./WCMobileHeader.vue?vue&type=style&index=0&id=4e83b177&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e83b177"]])

export default __exports__